<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide6',
  data() {
    return {
      parallax: [
        {
          start: 4300,
          end: 4800,
          fromStyle: { transform: 'translateY(-400px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(860px) rotateZ(12deg)' },
          easing: 'linear'
        },
        {
          start: 6800,
          end: 7400,
          fromStyle: { transform: 'translateY(860px) rotateZ(12deg)' },
          toStyle: { transform: 'translateY(2200px) rotateZ(-12deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/04_ChildCare.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 340px;
    height: 400px;
    left: -149px;
    top: calc(50% - 910px);
    transition: 0.6s;
    z-index: 3;
    @media(max-width: 600px) {
      width: 140px;
      left: -120px;
      top: calc(50% - 980px);
    }
}
</style>
